<template>
    <div class="cloud-wrap">
        <Library v-if="pinVerified" />
        <Container v-else-if="enforcedCmk" :center="true">
            <EnterPin :cid="enforcedCmk.id" @succeeded="handleVerified" />
        </Container>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import EnterPin from '@/components/EnterPin.vue';
import Container from '@/basic/Container.vue';
import Library from './Library.vue';
import store from '@/store';
import nprogress from 'nprogress';
import router from '@/router';
import { CMKManager } from '@/utils/cmk';
import { fetchIsHadSubAndNotExpiredProvider } from '@/service/dashboard';
import { getDeviceIdsHasVideo } from '@/api/cloud';

export default Vue.extend({
    components: {
        EnterPin,
        Library,
        Container
    },
    data () {

        return {
            enforcedCmk: null as null | Record<string, any>,
            pinVerified: false
        };

    },
    async created () {

        try {

            // 无套餐, e2eeTip
            if ( !await fetchIsHadSubAndNotExpiredProvider.providerGet( 1 )) {

                // 无视频
                const items = await getDeviceIdsHasVideo();
                if ( items.length === 0 ) {

                    await router.push( '/user/subscribe-plan/' );
                    return;

                }

            }
            // E2EETip, NoVideo
            await store.dispatch( 'getCMKS', 2 );

            const enforcedCMK = store.getters.enforcedCMK;

            if ( !enforcedCMK || CMKManager.isCMKVerified( enforcedCMK.id )) {

                this.verified();
                return;

            }

            CMKManager.Features.recordPinInStorage.initStorage();
            CMKManager.Features.recordPinInStorage.startRecord( enforcedCMK.id );
            this.enforcedCmk = enforcedCMK;

        } catch ( e ) {

            console.warn( e );

            this.verified();

        } finally {

            nprogress.done();

        }

    },
    methods: {
        verified () {

            this.pinVerified = true;

        },
        handleVerified () {

            this.verified();
            const enforcedCMKId = this.enforcedCmk!.id;
            CMKManager.Features.recordPinInStorage.stopRecord( enforcedCMKId );

            setTimeout(() => {

                for ( const cmk of store.getters.cmks ) {

                    const currentCid = cmk.id;
                    if ( currentCid === enforcedCMKId ) {

                        continue;

                    }

                    if ( !CMKManager.isCMKVerified( currentCid )) {

                        return;

                    }

                }

                // 如果没有未验证的 cmk
                CMKManager.Features.recordPinInStorage.del( enforcedCMKId );

            });

        }
    }
});
</script>
